// extracted by mini-css-extract-plugin
export default {"rangeForm":"RangeForm_rangeForm__AedqY"};